import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharingDataService } from 'src/app/Services/sharing-data.service';

@Component({
  selector: 'app-note-edit-dialog',
  templateUrl: './noteEditDialog.component.html',
  styleUrls: ['./noteEditDialog.component.css']
})
export class NoteEditDialogComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<NoteEditDialogComponent>,
    private shareData: SharingDataService,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) { }
  

  form: FormGroup;
  @Output() newNote = new EventEmitter<string>();
  resourceDefinition;


  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    if(this.data == null){
      this.data = "";
    }
    this.form = this.fb.group({
      newNoteValue: [`${this.data}`, Validators.maxLength(255)]
    });
  }

  btnSetAction() {
    if (this.form.valid) {
      this.newNote.emit(this.form.controls.newNoteValue.value);

      this.onClose();
    }

  }

  onClose() {
    this.form.reset();
    this.dialogRef.close();
  }

}
